import {Timeline, TimelineLite, TweenLite} from "gsap";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {TombOfAkhenatenParsedGameData} from "../server/data/TombOfAkhenatenParsedGameData";
import {TombOfAkhenatenGameModuleConfig} from "../TombOfAkhenatenGameModuleConfig";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {TOAGameEvent} from "../events/TOAGameEvent";
import {TombOfAkhenatenGameMode} from "../gameMode/TombOfAkhenatenGameMode";

export class WinEnd implements GameRoundPresentation {
    stagger?: number;
    abortStagger?: number;
    private _hasWin: boolean;
    private _tl: TimelineLite;

    constructor(stagger?: number, abortStagger?: number) {
        this.stagger = stagger;
        this.abortStagger = abortStagger;
        this.addEventListeners();
    }

    public getAnimation(data: TombOfAkhenatenParsedGameData, isAbort: boolean = false): Timeline | null {
        if(this._tl?.isActive()){
            this._tl?.pause().kill();
        }
        this._tl = new TimelineLite();


        this._tl.add(() => EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.HIDE_ALL_PYRAMID, true)))
        if (!this._hasWin) {
            if (this.isFreeSpinTriggered(data.mode, data.nextMode)) {
                this._tl.add(TweenLite.to({}, 1.5, {}));
                if(!isAbort){
                    EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.PLAY_SCATTER_END_ANIM));
                }
            }
            return this._tl;
        }

        let totalWinWaysWon: number = 0;
        for (let i: number = 0; i < data.betWins.length; i++) {
            const betWayWinData: IBetWayWinData = <IBetWayWinData>data.betWins[i];

            totalWinWaysWon = totalWinWaysWon + betWayWinData.numberOfCombinations;
        }
        if (this.isFreeSpinTriggered(data.mode, data.nextMode)) {
            this._tl.add(TweenLite.to({}, 1, {}));
        }
        if (data.isBigWin) {
            this._tl.add([
                TombOfAkhenatenGameModuleConfig.toaBigWinView.end(data.currentWinRatioConfig!, isAbort ? 0.5 : 0.5, isAbort ? 0.5 : 0.5 )
            ]);

            this._tl.add(()=>{
                TombOfAkhenatenGameModuleConfig.toaCountupView.moveCountUp(data.singleWin, isAbort ? 1.25 : 1.25, isAbort ? 0.3 : 0.3, data.payoutMultiplier == 1, totalWinWaysWon)
            });
            //#250 delay added for pyramid wild and normal win
            this._tl.add(TweenLite.to({}, data.pyramidReelLand.includes(true) ? 2 : 0.25, {}));
        } else {
            this._tl.add(() => TombOfAkhenatenGameModuleConfig.toaWinCountUp.getEndingAnimation(data.singleWin));
        }
        if (this.isFreeSpinTriggered(data.mode, data.nextMode)) {
            this._tl.add(TweenLite.to({}, 0.5, {}));
            if(!isAbort){
                TweenLite.delayedCall(0.5, ()=>{
                    EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.PLAY_SCATTER_END_ANIM));
                });
            }
        }
        return this._tl;
    }

    public abort(isActive: boolean, data: TombOfAkhenatenParsedGameData): Timeline | null {
        EventHandler.dispatchEvent(new GameEvent(TOAGameEvent.HIDE_ALL_PYRAMID));
        if (isActive && this._tl && this._tl.timeline) {
            if (this.isFreeSpinTriggered(data.mode, data.nextMode) || (SlotKeypad.autoplay.isAutoplayRound && data.isBigWin)) {
                return this.getAnimation(data, true);
            } else {
                //#402
                //GameRoundManager.detachAndPlayTimeline(this._tl);
                this._tl.progress(1);
            }
        } else {
            if (this._hasWin) {
                this.getAnimation(data);
            }
        }

        return null;
    }

    public prepare(data: ParsedGameData): void {
        this._hasWin = data.singleWin > 0;
    }

    protected addEventListeners(): void {
        EventHandler.addEventListener(this, TOAGameEvent.HIDE_WIN_AMOUNT_BEFORE_MULT_UPDATE, () => this.onUpdateMultiplier());
    }

    private isFreeSpinTriggered(mode: string, nextMode: string): boolean {
        return (mode == TombOfAkhenatenGameMode.NORMAL || mode == TombOfAkhenatenGameMode.RESPIN_FIRST ||
            mode == TombOfAkhenatenGameMode.RESPIN_SECOND || mode == TombOfAkhenatenGameMode.RESPIN_FINAL) && (
            nextMode == TombOfAkhenatenGameMode.FREESPIN || nextMode == TombOfAkhenatenGameMode.FS_RESPIN_FIRST ||
            nextMode == TombOfAkhenatenGameMode.FS_RESPIN_SECOND || nextMode == TombOfAkhenatenGameMode.FS_RESPIN_FINAL);
    }

    private onUpdateMultiplier(): void{
        if(this._tl?.isActive()){
            this._tl?.pause().kill();
            TombOfAkhenatenGameModuleConfig.toaCountupView.fadeAndRemove(0);
        }
    }
}